import React from 'react';
import { motion } from 'framer-motion';
import EditableField from './EditableField';
import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero__orbs">
        <div className="hero__orb hero__orb--1" />
        <div className="hero__orb hero__orb--2" />
        <div className="hero__orb hero__orb--3" />
      </div>
      <div className="hero__grid" />
      <div className="hero__content">
        <motion.div
          className="hero__badge"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <span className="hero__badge-dot" />
          <EditableField storageKey="hero-badge" defaultValue="Director & Philanthropist" tag="span" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <EditableField
            storageKey="hero-title"
            defaultValue="Hi, I'm Ramesh Genomal"
            tag="h1"
            className="hero__title"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <EditableField
            storageKey="hero-subtitle"
            defaultValue="Co-founder of Page Industries, Jockey India licensee, and founder of the Chummy Chum Foundation — dedicated to empowering children and building lasting legacies."
            tag="p"
            className="hero__subtitle"
            multiline
          />
        </motion.div>

        <motion.div
          className="hero__cta"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <a href="#about" className="hero__btn hero__btn--primary">My Story</a>
          <a href="#contact" className="hero__btn hero__btn--secondary">Get In Touch</a>
        </motion.div>
      </div>

      <motion.div
        className="hero__scroll"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
      >
        <span>SCROLL TO EXPLORE</span>
        <div className="hero__scroll-line" />
      </motion.div>
    </section>
  );
}

export default Hero;
